import { Component, OnInit, ViewChild, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TableComponent } from '../components/table/table.component';
import { environment } from '../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownComponent } from '../components/dropdown/dropdown.component';
import { AdminService } from '../../services/adminService';
import { DataUtils } from '../utils/DataUtils';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Observable, of, switchMap } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { DistrictService } from '../../services/districtService';
import { ToastModule } from 'primeng/toast';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ApiService } from '../../services/apiservice';
import { FloatLabelModule } from 'primeng/floatlabel';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { DatepickerComponent } from '../components/datepicker/datepicker.component';
import { MyMonitoringService } from '../../services/logging.service';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

@Component({
  selector: 'app-orders-by-name',
  standalone: true,
  imports: [ButtonModule, DatepickerComponent, ToastModule, FloatLabelModule, DatePickerModule, SelectModule, TableComponent, DropdownComponent, AutoCompleteModule, ProgressSpinnerModule, FormsModule, ConfirmPopupModule],
  templateUrl: './orders-by-name.component.html',
  styleUrl: './orders-by-name.component.scss',
  providers: [MessageService, AdminService, DatePipe, ConfirmationService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class OrdersByNameComponent implements OnInit {
  @ViewChild('tblConfig') tblConfig!: TableComponent;
  router: any;
  param: any;
  lsNorthDataColumns: any[] = [];
  actionButtons: any = [];
  nameOptions: SelectItem[] = [];
  typeOptions: SelectItem[] = [];
  districtOptions: SelectItem[] = [];
  scheduledDateOptions: SelectItem[] = [];
  empNameField: string = "Employee";
  empNamePlaceholder: string = "Employee";
  selectedName: string = "";
  selectedType: any;
  selectedDistrict: any;
  selectedScheduledDate: string = "";
  suggestions!: any[];
  allNameData: any[] = [];
  sortField: string = "";
  sortOrder: number = 1;
  searchText: any = "";

  filteredData$!: Observable<any[]>;
  queryData: any = {};
  isLoading = false;
  pageSize: number = 10;
  totalRecords: number = 2000;
  currentPage: number = 1;
  processMessage: string = "";



  constructor(
    private route: ActivatedRoute,
    private adminService: AdminService,
    private districtService: DistrictService,
    private messageService: MessageService,
    private monotoringService: MyMonitoringService,
    private redirectRoute: Router,
    private datePipe: DatePipe,
    private confirmationService: ConfirmationService,
    private apiService: ApiService
  ) {
    this.router = route;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.param = params.get('tier');
      this.tblConfig.searchValue = this.param;
    });

    const temp = JSON.parse(sessionStorage.getItem("queryData")!);

    this.queryData = temp;

    if (temp) {
      this.selectedDistrict = temp.data.District;
      this.selectedScheduledDate = temp.data.SchedDate;
      this.selectedType = temp.data.Type;
      this.selectedName = temp.data.Name;
      this.empNameField = temp.data.Name;

      if (this.selectedName) {
        this.search(temp.data.Name);
      }


      this.getSelectedOrderDetails();
      sessionStorage.removeItem("queryData")
    }
    this.LoadHeader();
    this.LoadDistricts();
  }

  LoadDistricts(): void {
    this.isLoading = true;
    this.processMessage = environment.appMessages.loadingMesage;

    this.apiService.groupId().pipe(
      switchMap(groupId => {
        return this.districtService.getDistricts(groupId);
      })
    ).subscribe({
      next: (data: any) => {
        this.districtOptions = DataUtils.createUniqueSortedList(data?.Payload.DistrictData.map((district: any) => ({
          label: district.District.trim(),
          value: district.District
        })));

        this.typeOptions = DataUtils.createUniqueSortedList(data?.Payload.OrderTypeData.map((type: any) => ({
          label: type.Value.trim(),
          value: type.Value
        })));

        if (this.queryData) {
          this.queryData = undefined;
        }
      },
      error: error => {
        this.isLoading = false;
        this.processMessage = '';
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'OrdersByNameComponent.LoadDistricts', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.isLoading = false;
        this.processMessage = '';
      }
    });
  }



  search(event: any) {
    try {
      this.apiService.groupId().pipe(
        switchMap(groupId => {
          return this.adminService.getOrderByModifiedName(event.query || this.selectedName, groupId);
        })
      ).subscribe({
        next: (data: any)=>{
          var arr = Array.from((data))
          this.suggestions = Array.from(new Set(arr));
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          this.showError("Failed to fetch order data. please try again later.");
        }
      })
      
    } catch (e) {
      this.showError("Failed to fetch order data. please try again later.");
    }
  }


  onNameSelect(event: any) {
    this.selectedName = event['value'];
  }

  showError(error: string) {
    this.messageService.add({ severity: 'warn', summary: 'Error', detail: error, life: 5000 });
  }

  LoadHeader(): void {

    this.lsNorthDataColumns = [
      { "field": "Name", "header": "EMPLOYEE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Type", "header": "TYPE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "District", "header": "DISTRICT", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "SchedDate", "header": "SCHED DATE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "State", "header": "STATE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "City", "header": "CITY", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "House", "header": "HOUSE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Street", "header": "STREET", "filter": true, "isSorting": true, "width": "10%" },
      {
        "field": "Update", "header": "ACTION", "filter": false, "isSorting": false, "width": "10%", type: "action",
        isClickable: 'true', onclick: this.handleClick.bind(this)
      }
    ];
  }
  handleClick(rowData: any): void {
    this.redirectRoute.navigate(['/order-entry', rowData.CCR_ID]);


    const temp = {
      data: {
        Name: this.selectedName,
        Type: this.selectedType,
        District: this.selectedDistrict,
        SchedDate: this.selectedScheduledDate
      },
      from: "/orders-by-name"
    }

    sessionStorage.setItem("queryData", JSON.stringify(temp))
  }
  onNameChange(event: any) {
    this.selectedName = event;
  }

  onTypeChange(event: any) {
    this.selectedType = event;
  }

  onDistrictChange(event: any) {
    this.selectedDistrict = event;
  }

  onScheduledDateChange(event: any) {
    this.selectedScheduledDate = event;
  }

  reload() {
    this.tblConfig.clear();
    this.LoadHeader();
  }

  onReloadClicked() {
    this.reload();
  }

  onCellClicked(event: any[]) {

  }

  getSearchDisabledStatus() {
    return this.selectedName === ""
  }

  onSearch(): void {
    this.currentPage = 1;
    this.tblConfig.resetPage();
    this.getSelectedOrderDetails();
  }

  onClear(): void {

    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-question',
      acceptButtonStyleClass: 'custom-accept-button',
      rejectButtonStyleClass: 'custom-reject-button',
      accept: () => {

        this.selectedType = "";
        this.selectedName = "";
        this.selectedScheduledDate = "";
        this.selectedDistrict = "";
        this.sortField = "";
        this.sortOrder = 1;
        this.searchText = "";
        this.filteredData$ = of([]);
        this.totalRecords = 0
      },

    });


  }

  onPageChanged(event: any): void {
    const pageSize = event.pageSize;
    const pageNumber = event.page; // zero-based page index    
    this.currentPage = pageNumber;
    this.pageSize = pageSize;
    this.getSelectedOrderDetails();
  }

  onSearchText(event: any): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.searchText = event.searchText;
    this.getSelectedOrderDetails();
  }

  onSortClicked(event: any): void {
    this.sortField = event.sortField;
    this.sortOrder = event.sortOrder;
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.getSelectedOrderDetails();
  }

  getSelectedOrderDetails(): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.apiService.groupId().pipe(
      switchMap(groupId => {
          const payload = {
            Name: this.selectedName === "" ? null : this.selectedName,
            Type: this.selectedType === "" ? null : this.selectedType,
            District: this.selectedDistrict === "" ? null : this.selectedDistrict,
            SchedDate: this.selectedScheduledDate === "" ? null : this.selectedScheduledDate,
            userId: sessionStorage.getItem('userId'),
            PageNumber: this.currentPage,
            PageSize: this.pageSize,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            SearchText: this.searchText,
            groupId: groupId

          }
        return this.adminService.getOrderDetailsByName(payload)
      })
    ).subscribe({
      next: (data: any) => {
        const totalRec = data?.Payload?.TotalRecords;
        const updatedData = data?.Payload?.Data.map((item: any) => {
          return {
            ...item,
            SchedDate: this.datePipe.transform(new Date(item.SchedDate.trim()), "MM-dd-yyyy")?.toString()
          }
        });
        // this.filteredData = updatedData; 
        this.filteredData$ = of(updatedData);
        this.totalRecords = totalRec;
        this.isLoading = false;

        if (data?.Payload?.Data?.length === 0) {
          const errMsg = environment.appMessages.noData
          this.messageService.add({ severity: 'warn', summary: 'No Data', detail: errMsg, life: environment.appSettings.snakbarLife });
        }
      },
      error: error => {
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.isLoading = false;
        this.monotoringService.logException({ name: 'OrdersByNameComponent.getSelectedOrderDetails', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }
}
